/**
 * AI Usage Limits & Plan Definitions
 *
 * Tracks how many "items" (transactions) a user processes through AI per month,
 * broken down per feature. Each AI endpoint counts differently:
 * - bulk-categorize / hybrid-categorize / bulk-generate-rules: count of transactions processed
 * - generate-rule: 1 per call
 * - generate-query: 1 per call
 */
export const AI_FEATURES = {
    BULK_CATEGORIZE: 'bulk-categorize',
    HYBRID_CATEGORIZE: 'hybrid-categorize',
    GENERATE_RULE: 'generate-rule',
    BULK_GENERATE_RULES: 'bulk-generate-rules',
    GENERATE_QUERY: 'generate-query',
};
export const AI_PLANS = {
    free: {
        name: 'Free',
        features: {
            'bulk-categorize': { monthlyItemLimit: 50 },
            'hybrid-categorize': { monthlyItemLimit: 50 },
            'generate-rule': { monthlyItemLimit: 1 },
            'bulk-generate-rules': { monthlyItemLimit: 100 },
            'generate-query': { monthlyItemLimit: 1 },
        },
    },
    smart: {
        name: 'Smart',
        features: {
            'bulk-categorize': { monthlyItemLimit: 2000 },
            'hybrid-categorize': { monthlyItemLimit: 2000 },
            'generate-rule': { monthlyItemLimit: 200 },
            'bulk-generate-rules': { monthlyItemLimit: 1000 },
            'generate-query': { monthlyItemLimit: 500 },
        },
    },
    pro: {
        name: 'Pro',
        features: {
            'bulk-categorize': { monthlyItemLimit: null },
            'hybrid-categorize': { monthlyItemLimit: null },
            'generate-rule': { monthlyItemLimit: null },
            'bulk-generate-rules': { monthlyItemLimit: null },
            'generate-query': { monthlyItemLimit: null },
        },
    },
};
/** Get the current billing period string (YYYY-MM) */
export function getCurrentPeriod() {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}
export const AI_ERROR_CODES = {
    USAGE_LIMIT: 'AI_USAGE_LIMIT',
};
export function isAIUsageLimitPayload(value) {
    return (typeof value === 'object' &&
        value !== null &&
        value.code === AI_ERROR_CODES.USAGE_LIMIT);
}
